import {Box, Typography} from '@mui/material';
import PropTypes from 'prop-types';

const WidgetTitle = ({title = '', idFieldValue = ''}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        alignItems: 'center',
        maxWidth: 800,
      }}
    >
      <Typography
        variant='h4'
        sx={{
          fontWeight: 700, // Override 500
          textTransform: 'uppercase',
          letterSpacing: '1px',
          color: 'secondary.main', // Full Onyx for high-contrast
        }}
      >
        {title}
      </Typography>

      {idFieldValue && (
        <Typography
          component='span'
          sx={{
            fontSize: 15,
            fontWeight: 700,
            color: 'primary.dark', // Yaman Gold ignition
          }}
        >
          {idFieldValue}
        </Typography>
      )}
    </Box>
  );
};

WidgetTitle.propTypes = {
  title: PropTypes.string,
  idFieldValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default WidgetTitle;
